import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PawIcon } from './Icons';
function LegalModal({
  title,
  onClose,
  children
}: {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.2
  }} className="fixed inset-0 z-[60] flex items-center justify-center p-4" onClick={onClose} data-id="element-46">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-47" />

      {/* Modal */}
      <motion.div initial={{
      opacity: 0,
      y: 20,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.97
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} className="relative bg-bg-card border border-white/10 rounded-2xl w-full max-w-lg max-h-[80vh] overflow-hidden shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-48">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/5" data-id="element-49">
          <h2 className="font-serif text-xl font-bold text-cream" data-id="element-50">{title}</h2>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full text-cream-muted hover:text-cream hover:bg-white/5 transition-colors" aria-label="Close" data-id="element-51">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4" data-id="element-52">
              <line x1="18" y1="6" x2="6" y2="18" data-id="element-53" />
              <line x1="6" y1="6" x2="18" y2="18" data-id="element-54" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-5 overflow-y-auto max-h-[calc(80vh-60px)] text-sm font-sans text-cream-muted leading-relaxed space-y-4" data-id="element-55">
          {children}
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="w-full bg-bg-primary border-t border-white/5 py-10" data-id="element-56">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center space-y-4" data-id="element-57">
          <div className="flex justify-center" data-id="element-58">
            <PawIcon className="w-5 h-5 text-cream-muted/25" data-id="element-59" />
          </div>
          <p className="font-sans text-xs text-cream-muted/50" data-id="element-60">
            The Longevity Bowl: Giant Breed Blueprint
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-61">
            <button onClick={() => setActiveModal('privacy')} className="font-sans text-xs text-cream-muted/40 hover:text-gold transition-colors underline underline-offset-2 decoration-cream-muted/20 hover:decoration-gold/50" data-id="element-62">
              Privacy Policy
            </button>
            <span className="text-cream-muted/20" data-id="element-63">|</span>
            <button onClick={() => setActiveModal('terms')} className="font-sans text-xs text-cream-muted/40 hover:text-gold transition-colors underline underline-offset-2 decoration-cream-muted/20 hover:decoration-gold/50" data-id="element-64">
              Terms of Service
            </button>
          </div>
          <p className="font-sans text-[10px] text-cream-muted/25 max-w-md mx-auto" data-id="element-65">
            This product is for informational purposes only and is not a
            substitute for professional veterinary advice.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-66">
        {activeModal === 'privacy' && <LegalModal title="Privacy Policy" onClose={() => setActiveModal(null)} data-id="element-67">
            <p className="text-cream font-medium" data-id="element-68">Effective Date: March 2026</p>
            <p data-id="element-69">
              Your privacy is important to us. This Privacy Policy explains how
              The Longevity Bowl ("we", "us", "our") collects, uses, and
              protects your personal information when you purchase or interact
              with our digital products.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-70">
              Information We Collect
            </h3>
            <p data-id="element-71">
              We collect information you provide directly, such as your name,
              email address, and payment details when you make a purchase. We
              also collect usage data through cookies and analytics tools to
              improve our services.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-72">
              How We Use Your Information
            </h3>
            <p data-id="element-73">
              We use your information to process transactions, deliver digital
              products, send order confirmations, and provide customer support.
              With your consent, we may also send promotional emails about
              related products.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-74">Data Protection</h3>
            <p data-id="element-75">
              We implement industry-standard security measures to protect your
              personal information. Your payment data is processed through
              secure, PCI-compliant payment processors and is never stored on
              our servers.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-76">
              Third-Party Sharing
            </h3>
            <p data-id="element-77">
              We do not sell, trade, or rent your personal information to third
              parties. We may share data with trusted service providers who
              assist in operating our website and processing payments.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-78">Your Rights</h3>
            <p data-id="element-79">
              You may request access to, correction of, or deletion of your
              personal data at any time by contacting us. You can also
              unsubscribe from marketing emails using the link provided in each
              email.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-80">Contact</h3>
            <p data-id="element-81">
              For questions about this Privacy Policy, please contact us at
              support@thelongevitybowl.com.
            </p>
          </LegalModal>}

        {activeModal === 'terms' && <LegalModal title="Terms of Service" onClose={() => setActiveModal(null)} data-id="element-82">
            <p className="text-cream font-medium" data-id="element-83">Effective Date: March 2026</p>
            <p data-id="element-84">
              By purchasing and using The Longevity Bowl: Giant Breed Blueprint
              ("the Product"), you agree to the following terms and conditions.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-85">Digital Product</h3>
            <p data-id="element-86">
              The Product is a digital information product delivered
              electronically. Upon purchase, you will receive immediate access
              to download the materials. All sales are subject to our 30-day
              money-back guarantee.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-87">
              30-Day Money-Back Guarantee
            </h3>
            <p data-id="element-88">
              If you are not satisfied with the Product for any reason, you may
              request a full refund within 30 days of purchase. Refund requests
              can be submitted by contacting our support team. You may keep all
              downloaded materials.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-89">Disclaimer</h3>
            <p data-id="element-90">
              The information provided in this Product is for educational and
              informational purposes only. It is not intended as a substitute
              for professional veterinary advice, diagnosis, or treatment.
              Always consult your veterinarian before making changes to your
              dog's diet.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-91">
              Intellectual Property
            </h3>
            <p data-id="element-92">
              All content within the Product is protected by copyright. You may
              not reproduce, distribute, or resell any part of the Product
              without written permission.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-93">
              Limitation of Liability
            </h3>
            <p data-id="element-94">
              We are not liable for any damages or adverse effects resulting
              from the use of information provided in the Product. Results may
              vary based on individual circumstances.
            </p>
            <h3 className="text-cream font-semibold mt-2" data-id="element-95">Contact</h3>
            <p data-id="element-96">
              For questions about these Terms, please contact us at
              support@thelongevitybowl.com.
            </p>
          </LegalModal>}
      </AnimatePresence>
    </>;
}